<template>
	<div class="py-8 max-w-7xl rounded-md mx-auto px-4 sm:px-6 lg:px-8">
		<div class="max-w-7xl mx-auto">
			<div class="">
				<div class="text-base text-primary-800 font-semibold tracking-wide uppercase">need more info?</div>
				<div class="text-2xl font-extrabold tracking-tight text-gray-700 sm:text-3xl">Watch our demo video</div>
				<div class="max-w-5xl sm:text-base text-gray-500 mt-1">
					If you still have questions visit our <router-link class="font-semibold underline" to="/faq">Frequently Asked Questions</router-link> page.
				</div>
			</div>
			<div class="video-container">
				<video controls width="640" height="360">
					<source :src="src" type="video/mp4" />
					Your browser does not support the video tag.
				</video>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Video',
	data() {
		return {
			src: `${process.env.VUE_APP_DASHDOCUMENTS_STORAGE}media/dashdocs-demo.mp4`,
		};
	},
};
</script>

<style scoped>
	.video-container {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 2rem;
	}
</style>
